import { Control } from "../Controls/Control";
import { AlignType } from "../Controls/ControlEnums";
import { ControlParams } from "../Controls/ControlInterfaces";
import { BaseAlignElement } from "./AlignPanels/BaseAlignElement";

export class VerticalScrollViewer extends Control {
    constructor(params: ControlParams) {
        super(params);

        this.element.classList.add("VerticalScrollViewer");

        this._changeDefinition();
    }

    // Prepsani inline css sirek/vysek na childech
    private _changeDefinition(): void {
        const cha = new BaseAlignElement(this.element);
        this.element.classList.add(AlignType[cha.alignType]);

        if (cha.alignType === AlignType.client) {
            this.element.style.minHeight = cha.height + "px";
            //this.Element.style.minWidth = cha.width + "px";
        } else {
            //this.Element.style.minHeight = "0%";
            this.element.style.height = cha.height + "px";
            this.element.style.width = cha.width + "px";
            this.element.style.minWidth = cha.width + "px";
            this.element.style.minHeight = cha.width + "px";
        }

        const children = Array.from(this.element.children) as HTMLElement[];
        for (const child of children) {
            const ch = new BaseAlignElement(child);

            child.style.width = "auto";
            child.style.width = "100%";
            // bude potreba nastavovat max/min-width?
            child.style.maxWidth = "100%";
            if (!child.classList.contains("dataGrid"))
                child.style.maxHeight = ch.height + "px";
            if (ch.alignType === AlignType.client) {
                child.style.minHeight = ch.height + "px";
                //child.style.minWidth = ch.width + "px";
            } else {
                //child.style.minHeight = "0%";
                //child.style.height = `${ch.height}px`;
                child.style.minHeight = ch.height + "px";
            }
        }
    }
}
